import { type QueryKeyRoot } from '../queryKeyRoots';

export const SUBSCRIPTION_QUERY_KEYS = {
  rfSubscriptionStatus: (assetId?: string) =>
    ['rfSubscriptionStatus', assetId] as const satisfies readonly [
      QueryKeyRoot,
      ...unknown[]
    ],
  subscriptionInfo: (family?: string) =>
    ['subscriptionInfo', family] as const satisfies readonly [
      QueryKeyRoot,
      ...unknown[]
    ],
} as const;
